import DashboardTotalSold from "./dashboard-total-sold";

export default DashboardTotalSold;
